export const copy = {
  it: {
    nav: { apartments: "Gli Appartamenti", amenities: "Servizi", reviews: "Recensioni", history: "La Storia", booking: "Prenota", contact: "Contatti" },
    hero: {
      overline: "Rovarè · Treviso",
      lines: ["Cinque ettari di storia,", "edifici storici,", "l'unicità di un'eredità veneta."],
      sub: "Villa Navagero Erizzo — holiday homes nella campagna trevigiana, tra giardini barocchi, statue e pietra d'Istria.",
      cta: "Prenota il tuo soggiorno",
      cta2: "Scopri gli appartamenti",
    },
    marquee: "Villa Navagero Erizzo · Villa Navagero Holiday Homes · ",
    apartments: {
      overline: "Le dimore",
      title: "Appartamenti circondati da natura e storia",
      sub: "Ogni appartamento è ricavato negli edifici storici del complesso — travi a vista, cotto, arredi d'epoca — circondato da cinque ettari di giardino.",
      guests: "ospiti",
      night: "notte",
      book: "Prenota",
      from: "da",
    },
    amenities: {
      overline: "Servizi comuni",
      title: "Piscina, tennis e cinque ettari di parco",
      sub: "Ogni appartamento ha i suoi spazi privati, ma la tenuta è di tutti gli ospiti: a disposizione piscina, campo da tennis e calcetto, e il grande parco storico.",
      items: [
        {
          title: "La piscina",
          text: "Una grande piscina immersa nel verde, con la statua dei delfini, lettini e ombrelloni: aperta a tutti gli ospiti della tenuta.",
        },
        {
          title: "Tennis e calcetto",
          text: "Il campo in erba tra i cipressi secolari, per una partita a tennis o a calcetto al tramonto.",
        },
        {
          title: "Il parco storico",
          text: "Cinque ettari di giardino barocco tra statue, viali e carpini secolari: perfetti per passeggiate, letture all'ombra e giochi all'aperto.",
        },
      ],
    },
    reviews: {
      overline: "Recensioni",
      title: "Le parole dei nostri ospiti",
      sub: "Le impressioni di chi ha soggiornato alla tenuta, condivise su Airbnb e Booking.",
    },
    history: {
      overline: "Note storico-artistiche",
      title: "Secoli di villa veneta",
      captions: {
        cian: "Il complesso “a volo d'uccello” · disegno a pastello di Alberto Cian, ante 1811",
        raphael: "Andrea Navagero e Agostino Beazzano · dipinto di Raffaello",
        granary: "La barchessa in una foto d'archivio",
        portichetto: "Il portichetto con le colonnine delle cedraie di Villa Da Lezze",
      },
      chapters: [
        {
          num: "01",
          title: "Lo spirito della villa veneta",
          paras: [
            "Villa Navagero è una residenza storica del XVI secolo che esprime, con naturale eleganza, il più autentico spirito delle ville venete. Un tempo cuore di una nobile tenuta agricola, in cui la dimora padronale si integrava armoniosamente con la vita produttiva dei campi, oggi si presenta come un luogo di rara bellezza dove storia, architettura e paesaggio dialogano in perfetta armonia.",
          ],
        },
        {
          num: "02",
          title: "Profilo architettonico",
          paras: [
            "Il disegno colorato a pastello del “pubblico perito agrimensore” Alberto Cian, collaboratore per molti decenni del proprietario dell'epoca Guido Erizzo, anteriore al 1811 — la località vi è indicata con il toponimo “Roveré” — offre una precisa immagine “a volo d'uccello” del fronte sud di tutto il complesso: i due piani dell'edificio centrale, le ali rientranti con camini di foggia carpaccesca, le barchesse arcuate, il cortile in masegni di pietra d'Istria e lo splendido giardino all'italiana con bordure e aiuole finemente disegnate.",
            "L'impianto interno ha la struttura collaudata delle costruzioni veneziane: due saloni sovrapposti con pavimenti in terrazzo alla veneziana e soffitti sansovineschi, attorno a cui ruotano otto stanze. All'originaria configurazione cinquecentesca fu aggiunto, verso la fine del Seicento, il piano superiore, raggiungibile da un elegante scalone — l'episodio architettonico più rilevante della villa — che, con il suo ballatoio in marmi policromi, reca i connotati certi di una firma illustre: Baldassarre Longhena, allora impegnato nella vicina Villa Da Lezze.",
            "Le chiavi di volta degli archi in pietra d'Istria sono finemente scolpite: guerrieri baffuti con elmo piumato al piano terra, aggraziati volti femminili al piano superiore. Tre archi sono ornati da mezzelune lignee a inflorescenze e racemi, di accuratissima fattura, che racchiudono lo scudo dorato dei Navagero: due bande sormontate dalla croce greca.",
            "Notevole anche il caminetto in marmo e stucco con lo stemma coronato dei Navagero e la mitica fenice — l'uccello che rinasce dal fuoco. La facciata sulla strada pubblica reca gli stemmi marmorei, con elmo, volute e piumaggi, dei Navagero e degli Erizzo; quella rivolta a sud è ornata da una meridiana e da uno zodiaco con paesaggi affrescati in monocromo.",
            "Elegantissime, per il gioco dei pieni e dei vuoti e il rincorrersi delle arcate, sono le due barchesse che si allungano come braccia monumentali verso il verde: archi a tutto sesto incorniciati da paraste in perfetto ordine toscano — tipologia ripresa nel 1818 da Guido Erizzo nella facciata del nuovo oratorio, dedicato alla Madonna del Rosario. Lo stesso Erizzo “inventa” il portichetto verso la foresteria, riutilizzando le agili colonnine provenienti dalle cedraie della vicina Villa Da Lezze.",
          ],
        },
        {
          num: "03",
          title: "Il riuso dopo l'azienda agricola",
          paras: [
            "Nel 1973, con la vendita degli ultimi quaranta ettari di terreno, cessò la secolare azienda agricola già dei Navagero e quindi degli Erizzo. La parte dominicale rimase fortunatamente intatta: la villa, le due barchesse, l'oratorio, il forno da pane ottocentesco, gli edifici già dei fittavoli Pasin, Stefani e Rocchetto, il grande Brolo a sud e il “Prà” a nord — circa cinque ettari con quattromila metri quadrati di edifici storici.",
            "Nel trentennio successivo gli otto edifici del complesso sono stati restaurati uno a uno, mantenendo l'interezza della proprietà. Sono tornati alla luce i due grandi viali coassiali di circa trecento metri a fronte nord e sud, l'antico “Stradon del Prà” ridestinato a viale d'accesso principale, il giardino all'italiana e il piccolo “teatro verde” a lato del brolo, con la sistemazione dei fossati che delimitano l'area dominicale.",
            "Il modello di riuso del complesso vincolato offre oggi soluzioni abitative particolarmente apprezzate per i vasti spazi verdi, le grandi alberature, la quiete assoluta e il sollievo offerto a chi vi soggiorna.",
          ],
        },
      ],
    },
    home: {
      overline: "Benvenuti",
      title: "Una tenuta storica, accoglienti dimore",
      text: "A Rovarè, nella campagna trevigiana, Villa Navagero Erizzo apre le porte dei suoi edifici storici a chi cerca quiete, natura e storia: appartamenti indipendenti, la piscina, il campo da tennis e cinque ettari di parco vi aspettano.",
      ctaApartments: "Scopri gli appartamenti",
      ctaBooking: "Prenota il tuo soggiorno",
    },
    booking: {
      overline: "Prenota",
      title: "Richiedi il tuo soggiorno",
      sub: "Scegliete l'appartamento, selezionate le date sul calendario — le date già occupate sono disabilitate — e inviate la richiesta: vi risponderemo al più presto.",
      choose: "Scegli l'appartamento",
      dates: "Date del soggiorno",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono (facoltativo)",
      guests: "Ospiti",
      message: "Messaggio (facoltativo)",
      nights: "notti",
      night: "notte",
      total: "Totale stimato",
      offers: "Offerte speciali: −5% per soggiorni oltre 3 notti · −10% oltre 7 notti",
      discount: "Sconto soggiorno lungo",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      success: "Richiesta inviata! Vi contatteremo presto.",
      paymentTitle: "Pagamento tramite bonifico bancario",
      paymentText: "Dopo la nostra conferma, potrai saldare il soggiorno con un bonifico sul conto della tenuta:",
      beneficiary: "Intestatario",
      amount: "Importo stimato",
      causale: "Causale",
      causalePrefix: "Prenotazione",
      paymentNote: "La tua richiesta è in attesa di conferma: ti risponderemo via email al più presto. Effettua il bonifico solo dopo la nostra conferma.",
      newRequest: "Invia un'altra richiesta",
      errorOverlap: "Le date selezionate non sono disponibili per questo appartamento.",
      errorGeneric: "Qualcosa è andato storto. Riprova o contattaci direttamente.",
      selectDates: "Seleziona arrivo e partenza",
      legend: "Le date in grigio sono già prenotate",
      consentPre: "Ho letto la",
      consentPost: "e acconsento al trattamento dei miei dati personali (Reg. UE 2016/679)",
    },
    contact: {
      overline: "Contatti",
      title: "Venite a trovarci",
      address: "Via Grande 2, 31048 Rovarè (TV)",
      emailLabel: "Scrivici",
      phoneLabel: "Chiamaci",
      directions: "Indicazioni stradali",
      garden: "La quiete della campagna e il relax vi aspettano qui a Villa Navagero.",
    },
    footer: "Villa Navagero Holiday Homes · Rovarè, Treviso",
  },
  en: {
    nav: { apartments: "Apartments", amenities: "Amenities", reviews: "Reviews", history: "The History", booking: "Book", contact: "Contact" },
    hero: {
      overline: "Rovarè · Treviso",
      lines: ["Five hectares of history,", "historic buildings,", "the uniqueness of a Venetian heritage."],
      sub: "Villa Navagero Erizzo — holiday homes in the Treviso countryside, among baroque gardens, statues and Istrian stone.",
      cta: "Book your stay",
      cta2: "Discover the apartments",
    },
    marquee: "Villa Navagero Erizzo · Villa Navagero Holiday Homes · ",
    apartments: {
      overline: "The residences",
      title: "Apartments surrounded by nature and history",
      sub: "Each apartment is set within the historic buildings of the estate — exposed beams, terracotta, period furnishings — surrounded by five hectares of gardens.",
      guests: "guests",
      night: "night",
      book: "Book",
      from: "from",
    },
    amenities: {
      overline: "Shared amenities",
      title: "Pool, tennis and five hectares of parkland",
      sub: "Every apartment has its own private spaces, but the estate belongs to all our guests: swimming pool, tennis and five-a-side court, and the great historic park.",
      items: [
        {
          title: "The swimming pool",
          text: "A large pool surrounded by greenery, with the dolphin statue, sun loungers and umbrellas: open to all guests of the estate.",
        },
        {
          title: "Tennis & five-a-side",
          text: "The grass court among centuries-old cypresses, for a game of tennis or football at sunset.",
        },
        {
          title: "The historic park",
          text: "Five hectares of baroque garden with statues, avenues and ancient hornbeams: perfect for walks, reading in the shade and outdoor games.",
        },
      ],
    },
    reviews: {
      overline: "Guest reviews",
      title: "In our guests' words",
      sub: "Impressions from those who stayed at the estate, shared on Airbnb and Booking.",
    },
    history: {
      overline: "Historical & artistic notes",
      title: "Centuries of Venetian villa life",
      captions: {
        cian: "The estate “from a bird's eye” · pastel drawing by Alberto Cian, before 1811",
        raphael: "Andrea Navagero and Agostino Beazzano · painting by Raphael",
        granary: "The barchessa in an archive photograph",
        portichetto: "The portico with columns from Villa Da Lezze's lemon houses",
      },
      chapters: [
        {
          num: "01",
          title: "The spirit of the Venetian villa",
          paras: [
            "Villa Navagero is a sixteenth-century historic residence that expresses, with natural elegance, the most authentic spirit of the Venetian villas. Once the heart of a noble agricultural estate, where the manor house blended harmoniously with the productive life of the fields, today it is a place of rare beauty where history, architecture and landscape dialogue in perfect harmony.",
          ],
        },
        {
          num: "02",
          title: "Architectural profile",
          paras: [
            "The pastel drawing by the “public surveyor” Alberto Cian — for decades a collaborator of the then owner Guido Erizzo — predates 1811, as the place is marked with the toponym “Roveré”. It offers a precise bird's-eye view of the southern front of the whole complex: the two floors of the central building, the recessed wings with their Carpaccio-style chimneys, the arched barns, the courtyard paved with Istrian stone slabs and the splendid Italian garden with finely drawn borders and flowerbeds.",
            "The interior layout follows the tried-and-tested structure of Venetian buildings: two superimposed halls with Venetian terrazzo floors and Sansovinian ceilings, around which eight rooms revolve. To the original sixteenth-century configuration, the upper floor was added towards the end of the seventeenth century, reached by an elegant staircase — the villa's most significant architectural episode — which, with its polychrome marble landing, bears the certain marks of an illustrious signature: Baldassarre Longhena, then working on nearby Villa Da Lezze.",
            "The keystone corbels of the Istrian stone arches are finely carved: moustached warriors with plumed helmets on the ground floor, graceful female faces above. Three arches are adorned with exquisitely carved wooden half-moons of inflorescences and clusters, enclosing the gilded Navagero shield: two bends surmounted by a Greek cross.",
            "Also remarkable is the marble and stucco fireplace with the crowned Navagero coat of arms and the mythical phoenix — the bird reborn from fire. The façade overlooking the public road bears the elaborate marble crests of the Navagero and the Erizzo; the south-facing one is adorned with a sundial and a frescoed zodiac.",
            "Most elegant, for their play of solids and voids and the rhythm of the arches, are the two barchesse stretching like monumental arms towards the greenery: round arches framed by pilasters in perfect Tuscan order — a style taken up in 1818 by Guido Erizzo in the façade of the new oratory, dedicated to the Madonna del Rosario. Erizzo also “invented” the little portico to the guesthouse, reusing the slender columns from the lemon houses of nearby Villa Da Lezze.",
          ],
        },
        {
          num: "03",
          title: "Reuse after the farm era",
          paras: [
            "In 1973, with the sale of the last forty hectares, the centuries-old farm of the Navagero and then the Erizzo came to an end. Fortunately the manor core remained intact: the villa, the two barchesse, the oratory, the nineteenth-century bread oven, the buildings once run by the Pasin, Stefani and Rocchetto tenant farmers, the great Brolo to the south and the “Prà” to the north — about five hectares with four thousand square metres of historic buildings.",
            "Over the following thirty years the eight buildings of the complex were restored one by one, keeping the property whole. The two great three-hundred-metre coaxial avenues to the north and south were brought back to light, along with the ancient “Stradon del Prà” as the main driveway, the Italian garden and the little “green theatre” beside the brolo, with the ditches delimiting the grounds restored.",
            "The reuse model of this listed complex now offers living solutions especially appreciated for its vast green spaces, its great trees and the absolute quiet of the whole estate.",
          ],
        },
      ],
    },
    home: {
      overline: "Welcome",
      title: "A historic estate, five residences",
      text: "In Rovarè, in the Treviso countryside, Villa Navagero Erizzo opens the doors of its historic buildings to those seeking peace, nature and history: five independent apartments, the pool, the tennis court and five hectares of parkland await you.",
      ctaApartments: "Discover the apartments",
      ctaBooking: "Book your stay",
    },
    booking: {
      overline: "Book",
      title: "Request your stay",
      sub: "Choose your apartment, pick your dates on the calendar — occupied dates are disabled — and send your request: we will reply as soon as possible.",
      choose: "Choose the apartment",
      dates: "Stay dates",
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      guests: "Guests",
      message: "Message (optional)",
      nights: "nights",
      night: "night",
      total: "Estimated total",
      offers: "Special offers: 5% off for stays longer than 3 nights · 10% off over 7 nights",
      discount: "Long-stay discount",
      submit: "Send request",
      sending: "Sending…",
      success: "Request sent! We will contact you soon.",
      paymentTitle: "Payment by bank transfer",
      paymentText: "After our confirmation, you can pay for your stay by bank transfer to the estate's account:",
      beneficiary: "Beneficiary",
      amount: "Estimated amount",
      causale: "Reference",
      causalePrefix: "Booking",
      paymentNote: "Your request is pending confirmation: we will reply by email shortly. Please make the transfer only after our confirmation.",
      newRequest: "Send another request",
      errorOverlap: "The selected dates are not available for this apartment.",
      errorGeneric: "Something went wrong. Please try again or contact us directly.",
      selectDates: "Select arrival and departure",
      legend: "Greyed-out dates are already booked",
      consentPre: "I have read the",
      consentPost: "and I consent to the processing of my personal data (EU Reg. 2016/679)",
    },
    contact: {
      overline: "Contact",
      title: "Come and visit us",
      address: "Via Grande 2, 31048 Rovarè (TV) · Italy",
      emailLabel: "Write to us",
      phoneLabel: "Call us",
      directions: "Get directions",
      garden: "The quiet of the countryside and relaxation await you here at Villa Navagero.",
    },
    footer: "Villa Navagero Holiday Homes · Rovarè, Treviso",
  },
};
